import React, { useState } from "react";
import "./styles.less";
import { priceFunData } from "./priceFun";
import { useTranslation } from "react-i18next";
import Tooltip from "rc-tooltip";

export const PriceSystemCompare = ({ currentType }) => {
  const [, setAction] = useState();
  const { t } = useTranslation();

  // 渐变 tag
  const tagList =
    currentType === "b2e"
      ? [
          { title: "", style: { background: "none" } },
          { title: t("price.compare.free"), style: { opacity: 0.4 } },
          { title: t("price.compare.develop-pro"), style: { opacity: 0.6 } },
          { title: t("price.compare.enterprise"), style: { flex: 1 } },
        ]
      : [
          { title: "", style: { background: "none" } },
          { title: t("price.compare.free"), style: { opacity: 0.4 } },
          { title: t("price.compare.develop"), style: { opacity: 0.6 } },
          { title: t("price.compare.develop-pro"), style: { opacity: 0.8 } },
          { title: t("price.compare.enterprise"), style: { flex: 1 } },
        ];

  return (
    <div className="priceSystemCompare-container">
      <div className="title">{t("price.compare.title")}</div>
      <div className="tag-container">
        {tagList.map((item, index) => (
          <div className="item" key={index + "amsl"} style={item.style ?? {}}>
            {item.title}
          </div>
        ))}
      </div>
      {priceFunData[currentType].map((item, index) => (
        <div className="select-box" key={index + "masl"}>
          <div
            className="title"
            onClick={() => {
              setAction([
                ...priceFunData[currentType],
                (priceFunData[currentType][index] = {
                  ...priceFunData[currentType][index],
                  active: !priceFunData[currentType][index].active,
                }),
              ]);
            }}
          >
            {t(`${item.title}`)}
            <div
              className={
                priceFunData[currentType][index].active
                  ? "rotate180"
                  : "rotate90"
              }
            >
              <i className="icon authing-icon authing-arrow-down-line"></i>
            </div>
          </div>
          {priceFunData[currentType][index].active && (
            <div className="body">
              {item.list.map((_item, _index) => {
                const des = item.des[_index];
                return (
                  <div className="item" key={_index + "mlaaa"}>
                    {_item.map((item, idx) => (
                      <div className="content-box" key={idx + "laq1"}>
                        {item === "checked" ? (
                          <i
                            className="icon authing-icon authing-wancheng"
                            style={{ color: "#1FCE8B" }}
                          ></i>
                        ) : (
                          t(`${item}`)
                        )}

                        {idx === 0 && (
                          <div>
                            <Tooltip
                              placement="right"
                              mouseLeaveDelay={0.001}
                              trigger={["hover"]}
                              overlay={<div>{t(`${des}`)}</div>}
                              overlayClassName="context-box-tooltip"
                            >
                              <span>
                                <i
                                  className="icon authing-icon authing-question-line"
                                  style={{ color: "#aaaaaa", marginLeft: 6 }}
                                ></i>
                              </span>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
